module.exports = __webpack_public_path__ + "assets/baoxiao.a5b91ea909794d297bb954e5628cc5bf.png";